import CollaborationCard from 'Components/collaboration/legacy/CollaborationCard';
import React, { useEffect, useRef, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component';
import Skeleton from 'react-loading-skeleton';
import { useDispatch, useSelector } from 'react-redux'
import { Container } from 'reactstrap';
import { searchLegacyCollaborationsList, updateLegacyCollaborationsListFilters } from 'slices/legacy-collaborations/reducer';
import { fetchLegacyCollaborationsListThunk } from 'slices/legacy-collaborations/thunk';
import { AppDispatch, RootState } from 'store'
import { CollaborationsLegacyFilters } from 'types/collaboration-legacy';
import { generateUniqueKey } from 'utils/helpers';

const Collaborations = () => {

    const filters = useSelector((state: RootState) => state.legacyCollaborations.filters);
    const [filterId, setFilterId] = useState(generateUniqueKey(filters, ['page']));
    const [searchQuery, setSearchQuery] = useState('');

    const dispatch: AppDispatch = useDispatch();

    const collaborationsData = useSelector((state: RootState) => state.legacyCollaborations.filtered_lists[filterId!]);
    const collaborations = collaborationsData?.list ?? [];
    const page = collaborationsData?.page ?? 1;
    const has_more = collaborationsData?.has_more ?? true;

    const loading = useSelector((state: RootState) => state.legacyCollaborations.loading);

    const [initialLoading, setInitialLoading] = useState(true);

    useEffect(() => {
        setInitialLoading(true);
        dispatch(fetchLegacyCollaborationsListThunk({ filters })).finally(() => {
            setFilterId(generateUniqueKey(filters, ['page']));
            setInitialLoading(false);
        })
    }, [filters])

    const nextPage = () => {
        if (has_more) {
            const nextPageNumber = page + 1;
            dispatch(fetchLegacyCollaborationsListThunk({ filters: { ...filters, page: nextPageNumber } }))
        }
    }

    const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (debounceTimeout.current) {
            clearTimeout(debounceTimeout.current);
        }

        debounceTimeout.current = setTimeout(() => {
            if (searchQuery.trim().length > 2 || searchQuery.trim().length === 0) {
                dispatch(searchLegacyCollaborationsList(searchQuery));
            } 
        }, 500);

        return () => {
            if (debounceTimeout.current) {
                clearTimeout(debounceTimeout.current);
            }
        };
    }, [searchQuery]);

    return (
        <div className="page-content mb-3">
            <Container fluid>
                <div className="d-flex align-items-md-center justify-content-between flex-md-row flex-column mb-4 gap-2">
                    <h3 className="page-title m-0">Collaborations</h3>
                    <div className="search-box">
                        <input
                            id="search-user"
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        <i className="ri-search-2-line search-icon"></i>
                        {
                            searchQuery &&
                            <i className="ri-close-line clear-search-icon" onClick={() => setSearchQuery('')}></i>
                        }
                    </div>
                </div>

                <InfiniteScroll
                    dataLength={collaborations.length}
                    next={nextPage}
                    hasMore={has_more}
                    loader={<></>}
                    className='row g-3'
                >
                    {
                        !initialLoading && collaborations.length > 0 && collaborations.map((collaboration, index) => {
                            return (
                                <div key={index} className='col-xl-3 col-lg-4 col-md-6 col-sm-6 pe-1'>
                                    <CollaborationCard collaboration={collaboration} />
                                </div>
                            )
                        })
                    }
                    {
                        (initialLoading || loading) && Array.from({length: 8}).map((_, index) => {
                            return (
                                <div key={index} className='col-xl-3 col-lg-4 col-md-6 col-sm-6 pe-1'>
                                    <Skeleton height={100} className='rounded-3' />
                                </div>
                            )
                        })
                    }
                </InfiniteScroll>
            </Container>
        </div>
    )
}

export default Collaborations